import { useState } from "react";
import { useSession, useSignIn } from "../../Recoil/Session/Session";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { fn } from "../../Functions";

const Setting = () => {

    const { session } = useSession();

    const [ isLogOutModalOpen , setIsLogOutModalOpen ] = useState<boolean>(false);
    const [ isDeleteAccountModalOpen , setIsDeleteAccountModalOpen ] = useState<boolean>(false);

    return (<div className={"MyPageArea"}>
        <div className={"MyPageInner"} >
            <section className={"Header"} >
                <IconButton
                    onClick={fn.gotoByAnchor}
                    href={"/mypage"}
                >
                    <img 
                        src={"https://static.novela.today/icon/chevron_left_thick.svg"} 
                        alt={"chevron"} width={24} height={24} 
                    />
                </IconButton>
                <span>계정 정보</span>
            </section>
            <section className={"Body"} >
                <div className={"EmailBox"}>
                    <div className={"EmailTitle"} >
                        {"이메일"}
                    </div>
                    <div className={"Email"} >
                        {`${session.email}`}
                    </div>
                </div>
                <Button className={"logoutBox"} onClick={() => setIsLogOutModalOpen(true)} >
                    <div>{"로그아웃"}</div>
                    <img src={"https://static.novela.today/icon/chevron_right_thick.svg"} alt={"chevron"} width={24} height={24} />
                </Button>
                <div className={"Divider"} ></div>
                <Button className={"DeleteBox"} onClick={() => setIsDeleteAccountModalOpen(true)} >
                    <div>{"서비스 탈퇴"}</div>
                    <img src={"https://static.novela.today/icon/chevron_right_thick.svg"} alt={"chevron"} width={24} height={24} />
                </Button>
            </section>
            <section className={"Footer"} >
                <div className={"FooterText"}>{"사용 중 불편한 점이나 궁금한 사항이 있으시면"}</div>
                <div className={"FooterText"}>
                    {"언제든 "}    
                    <a href="mailto:help@webtoon.today">{"help@webtoon.today"}</a>
                    {"로 문의주시기 바랍니다."}
                </div>
            </section>
        </div>
        {isLogOutModalOpen 
            && <LogOutModal open={isLogOutModalOpen} onClose={() => setIsLogOutModalOpen(false)} />}
        {isDeleteAccountModalOpen
            && <DeleteAccountModal open={isDeleteAccountModalOpen} onClose={ () => setIsDeleteAccountModalOpen(false)} />}
    </div>)
}

const LogOutModal = ({open, onClose}:{open: boolean, onClose: () => void}) => {

    const { logout } = useSignIn();

    return(
    <Dialog 
        className={"LogOutModal"} 
        open={open} onClose={onClose} 
        PaperProps={{sx: {
            width: "328px", borderRadius: "16px", 
            boxShadow: "0px 14px 50px 15px rgba(12, 22, 39, 0.12), 0px 0px 0px 1px rgba(12, 22, 39, 0.05)"
        }}} 
    >
        <DialogTitle className={"LogOutTitle"} >
            {"로그아웃 하시겠습니까?"}
        </DialogTitle>
        <DialogActions className="LogOutActions">
            <Button className="LogOutButton" fullWidth onClick={async () => {fn.goto("/"); await logout();}}  >{"로그아웃"}</Button>
            <Button className="CancelButton" fullWidth onClick={onClose} >{"취소"}</Button>   
        </DialogActions>
    </Dialog>)
}

const DeleteAccountModal = ({open, onClose}:{open: boolean, onClose: () => void}) => {

    return(
    <Dialog
        className={"DeleteAccountModal"} 
        open={open} onClose={onClose} 
        PaperProps={{sx: {
            width: "328px",
            boxShadow: "0px 14px 50px 15px rgba(12, 22, 39, 0.12), 0px 0px 0px 1px rgba(12, 22, 39, 0.05)"
        }}} 
    >
        <DialogTitle className={"DeleteAccountTitle"} >
            <div className={"Title"} >{"서비스 탈퇴를 하시겠습니까?"}</div>
            <div className={"SubTitle"} >{"탈퇴 시 계정 정보 및 구매한 열람권은\n영구적으로 삭제됩니다."}</div>
        </DialogTitle>
        <DialogContent className={"DeleteAccountContent"} >
        </DialogContent>
        <DialogActions className="LogOutActions">
            <Button className="DeleteAccountButton" fullWidth >{"서비스 탈퇴하기"}</Button>
            <Button className="CancelButton" fullWidth onClick={onClose} >{"취소"}</Button>   
        </DialogActions>
    </Dialog>)
}


export default Setting;